// @core/api/endpoints/form/review_form_submission.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormSubmissionResponse,
  ReviewFormSubmissionRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Review form submission
 * Reviews a submission by approving or rejecting it.
 */
export async function ReviewFormSubmission(
  submission_id: string,
  data: ReviewFormSubmissionRequest,
  options?: RequestOptions
): Promise<FormSubmissionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/submissions/:submission_id/review`;
  requestPath = requestPath.replace(':submission_id', encodeURIComponent(submission_id));
  const requestOptions = options;
  return client.post<FormSubmissionResponse>(requestPath, data, requestOptions);
}
